module.exports = __webpack_public_path__ + "static/media/triangle.af0ee3aa.svg";